<template>
  <a-modal
          title="到期自动提醒设定"
          okText="确认"
          cancelText="取消"
          width="800px"
          :visible="visible"
          :confirm-loading="confirmLoading"
          @ok="handleOk"
          @cancel="handleCancel"
  >
    <a-form-model ref="ruleForm" :model="formState" :rules="rules" :label-col="{span:8}" :wrapper-col="{span:16}">
      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="触发时间" prop="minDays">
            <a-ext-local-dic-select dic-key="SendMsgDays" v-model="formState.minDays"></a-ext-local-dic-select>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="发送时间" prop="sendTimeType">
            <a-ext-local-dic-select dic-key="SendMsgTime" v-model="formState.sendTimeType"></a-ext-local-dic-select>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="短信内容" prop="content">
            <a-input  type="textarea"  v-model="formState.content"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

    </a-form-model>

  </a-modal>
</template>

<script>

import AExtLocalDicSelect from '../../../components/AntDesignExt/All/AExtLocalDicSelect'
import {addorUpdateOCheckerCardMsgRule as saveApi,getOCheckerCardMsgRuleById as initApi} from '../../../api/api'
import {FormRules} from 'antd-form-rules';
export default {
    name: "FormModel",
    components:{
        AExtLocalDicSelect,},
    props:{
        visible:{
            type:Boolean,
            default:false
        },
        param:{
            type:Object,
            default: ()=>{
                return {}
            }
        }
    },
    data() {
        return {
            confirmLoading: false,
            formState: {
                minDays:'',
                sendTimeType:'',
                content:'',
            },
            rules: {
                sendTimeType: FormRules.withName('发送时间').string(1, 50).isRequired().create(),
                content: FormRules.withName('短信内容').string(1, 50).isRequired().create(),
            },

        };
    },
    created(){
        this.initForm();
    },
    methods: {
        initForm(){
              this.confirmLoading = true;
              initApi({id:'5321eda14f9746f4a5dbf862d073c24f'}).then((result => {
                  if(result.data&&result.data.data) {
                      this.formState = result.data.data;
                  }
                  this.confirmLoading = false;
              })).catch(() => {
                  this.confirmLoading = false;
              });
        },
        handleOk(e) {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.confirmLoading = true;
                    saveApi(this.formState).then((result=>{
                        this.confirmLoading = false;
                        this.$emit("alertSetModalClose",true)
                        this.$emit("update:visible",false)
                    })).catch(()=>{
                        this.confirmLoading = false;
                    });
                } else {
                    return false;
                }
            });
        },
        handleCancel(e) {
            this.$emit("update:visible",false)
        },

    },
}
</script>

<style scoped lang="scss">

  /deep/ .ant-modal-body{
    /*height: 60vh;*/
    /*overflow-y: scroll;*/
  }

</style>